import React, { useState } from 'react';
import { Button, Center, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import MuiIcon from 'components/MuiIcon';
import { useForm, SubmitHandler, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCreateService } from 'shared/api/requests/services';
import TextField from 'shared/components/form/TextField';
import { CreateServiceFormT, createServiceResolver, getCreateServiceValues } from 'shared/form-values/services';
import useGetColors from 'shared/hooks/useGetColors';
import { fillFormErrors } from 'shared/utils/devUtils';

const AddServiceModal = () => {
  const { t } = useTranslation();
  const { gray800, gray100, themeAccentColor } = useGetColors();
  const [isOpen, setIsOpen] = useState(false);
  const { mutate, isPending } = useCreateService();

  const methods = useForm<CreateServiceFormT>({
    defaultValues: getCreateServiceValues(),
    resolver: createServiceResolver,
    mode: "onChange"
  });

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);
  const onSubmit: SubmitHandler<CreateServiceFormT> = (values) => {
    return mutate(values, {
      onError: (error) => fillFormErrors(methods.setError, error),
      onSuccess: onClose,
    });
  };

  const fieldProps = {
    mb: '20px',
    w: '100%'
  };

  return (
    <>
      <Button
        color={gray800}
        bgColor={gray100}
        borderRadius="8px"
        onClick={onOpen}
        w="100%"
      >
        <Center>
          <MuiIcon name="add" size={24} />
          <Text ml="10px">{t("Add module")}</Text>
        </Center>
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("Add module")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onSubmit)}>
                <TextField<CreateServiceFormT>
                  name="name"
                  label="Name"
                  required
                  {...fieldProps}
                />
                <TextField<CreateServiceFormT>
                  name="domain"
                  label="Domain"
                  required
                  {...fieldProps}
                />
                <TextField<CreateServiceFormT>
                  name="token"
                  label="Token"
                  required
                  {...fieldProps}
                />
                <Center w="100%">
                  <Button
                    colorScheme={themeAccentColor}
                    borderRadius="8px"
                    type="submit"
                    w="100px"
                    isLoading={isPending}
                  >
                    {t('buttons.create')}
                  </Button>
                </Center>
              </form>
            </FormProvider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AddServiceModal;
